var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "calendar_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7.992H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-10-2a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4H7z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.031 12.992H5v-2h14.03v2zM8 3.992a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1zm8 0a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z",
    fill: "currentColor"
  })));
};

export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3IDcuOTkySDdhMiAyIDAgMDAtMiAydjhhMiAyIDAgMDAyIDJoMTBhMiAyIDAgMDAyLTJ2LThhMiAyIDAgMDAtMi0yem0tMTAtMmE0IDQgMCAwMC00IDR2OGE0IDQgMCAwMDQgNGgxMGE0IDQgMCAwMDQtNHYtOGE0IDQgMCAwMC00LTRIN3oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuMDMxIDEyLjk5Mkg1di0yaDE0LjAzdjJ6TTggMy45OTJhMSAxIDAgMDAtMSAxdjRhMSAxIDAgMTAyIDB2LTRhMSAxIDAgMDAtMS0xem04IDBhMSAxIDAgMDAtMSAxdjRhMSAxIDAgMTAyIDB2LTRhMSAxIDAgMDAtMS0xeiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";